import React from 'react';

import { Icon } from '@gitbook/spine-icons';

/**
 * Large circular badge with a nice animation to indicate that something is done.
 */
export function BadgeCompletion(props: {
    /**
     * Delay before the badge is marked as done.
     */
    delay?: number;
}) {
    const { delay = 400 } = props;

    const [isDone, setIsDone] = React.useState(false);

    React.useEffect(() => {
        const timeout = setTimeout(() => {
            setIsDone(true);
        }, delay);

        return () => clearTimeout(timeout);
    }, [delay]);

    return (
        <div className="flex items-center justify-center rounded-full bg-action-success p-2">
            <Icon.AnimatedCheck size={16} isSelected={isDone} className="shrink-0 text-inverted" />
        </div>
    );
}
